module.exports = __webpack_public_path__ + "img/Hayley-Zammit.e28571f1.jpeg";